module.exports = __webpack_public_path__ + "images/all-skus-black-6befb946.svg";